import { useValidatePatientAgeWarningDialog } from '../common/useValidatePatientAgeWarningDialog';
import { useCallback } from 'react';
import { BookPatientApptsProps } from '../common/appointmentFormHooks';
import { useReferrerOptions } from '../../../../utils/options';
import { useAllGPSurgeries } from '../../../../hooks/referrals/useAllGPSurgeries';

export const useStaffAppointmentBookWithPatient = ({
  bookPatientAppointment,
}: {
  bookPatientAppointment: (props: BookPatientApptsProps) => void;
}) => {
  const { showSitePatientAgeWarningIfNeeded } =
    useValidatePatientAgeWarningDialog();

  const bookPatientWithAgeValidation = useCallback(
    ({ user, ...rest }: BookPatientApptsProps) => {
      showSitePatientAgeWarningIfNeeded({
        onSuccess: () =>
          bookPatientAppointment({
            user,
            ...rest,
          }),
        user: user,
      });
    },
    [showSitePatientAgeWarningIfNeeded, bookPatientAppointment],
  );

  const { isLoading: isSurgeriesLoading, data: surgeriesResponse } =
    useAllGPSurgeries();

  const { isLoading: isReferrersLoading, referrerOptions } =
    useReferrerOptions();

  return {
    bookPatientWithAgeValidation,
    isLoading: isSurgeriesLoading || isReferrersLoading,
    surgeriesResponse,
    referrerOptions,
  };
};
